import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/site/PageHeader";
import { EstimateForm } from "@/components/site/EstimateForm";
import { CTASection } from "@/components/site/CTASection";
import commercialAsset from "@/assets/commercial-lobby.jpg.asset.json";
const commercialImg = commercialAsset.url;

export const Route = createFileRoute("/commercial")({
  head: () => ({
    meta: [
      { title: "Commercial Painting in Wisconsin — Michael's Painting" },
      { name: "description", content: "Commercial painting for offices, retail, apartments, HOAs, warehouses, and new construction across Wisconsin. Clean, professional, on schedule." },
      { property: "og:title", content: "Commercial Painting in Wisconsin" },
      { property: "og:description", content: "Commercial painting for offices, retail, apartments, HOAs, and tenant improvements." },
      { property: "og:url", content: "https://michaelspaintingwi.com/commercial" },
      { property: "og:image", content: `https://michaelspaintingwi.com${commercialAsset.url}` },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: `https://michaelspaintingwi.com${commercialAsset.url}` },
    ],
    links: [{ rel: "canonical", href: "https://michaelspaintingwi.com/commercial" }],
  }),
  component: CommercialPage,
});

const SECTORS = [
  "Office & Corporate", "Retail & Hospitality", "Apartments & Multi-Family",
  "HOA & Property Management", "Warehouses & Light Industrial", "Restaurants",
  "New Construction", "Tenant Improvements",
];

function CommercialPage() {
  return (
    <>
      <PageHeader eyebrow="Commercial Painting" title="Professional painting for the properties Wisconsin works in." subtitle="Flexible scheduling, clean staging, and durable coating systems for offices, retail, apartments, and commercial buildings." />
      <section className="py-24 lg:py-32 bg-brand-ivory">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-[1.2fr,1fr] gap-16 items-start">
          <div>
            <h2 className="font-serif text-4xl text-brand-navy mb-6 text-balance">Minimal disruption. Maximum durability.</h2>
            <p className="text-zinc-400 mb-6 leading-relaxed">We work after hours, on weekends, and in phased zones so your business never stops. Our commercial coating systems are specified for traffic, climate, and longevity — not just appearance.</p>
            <img src={commercialImg} alt="Commercial painting Wisconsin" loading="lazy" className="rounded-md w-full mt-6" />
            <h3 className="font-serif text-2xl text-brand-navy mt-12 mb-6">Sectors we serve</h3>
            <div className="grid grid-cols-2 gap-3">
              {SECTORS.map((s) => (
                <div key={s} className="flex items-center gap-3 text-sm text-zinc-700">
                  <span className="size-1.5 rounded-full bg-brand-brass" /> {s}
                </div>
              ))}
            </div>
          </div>
          <div className="lg:sticky lg:top-28"><EstimateForm /></div>
        </div>
      </section>
      <CTASection title="Schedule your commercial repaint." subtitle="We'll meet you on-site, scope the project, and deliver a fixed-price proposal." />
    </>
  );
}
